// Insights hub cards. The build pre-renders them into the page
// (data-prerendered); this script only renders when that did not happen,
// e.g. when a page is opened straight from the source tree.
document.addEventListener("DOMContentLoaded", () => {
  const gridEl = document.getElementById("insightsArticles");
  const cards = window.ForsytInsightsCards;
  if (!gridEl || !cards || gridEl.dataset.prerendered) return;

  const href = (link) => new URL(link.replace(/^\//, ""), document.baseURI).toString();
  let data = null;
  let failed = false;

  const render = () => {
    const lang = window.forsytLang || "en";
    if (failed) {
      gridEl.innerHTML = cards.unavailable("hub", lang);
      return;
    }
    if (!data) return;
    gridEl.innerHTML = cards.hubCards(data.articles || [], lang, href, "scroll-reveal active");
  };

  document.addEventListener("forsyt:langchange", render);
  fetch(new URL("data/insights-index.json", document.baseURI))
    .then((r) => {
      if (!r.ok) throw new Error("Failed to load insights index.");
      return r.json();
    })
    .then((json) => {
      data = json;
      render();
    })
    .catch((error) => {
      console.error("Insights hub load error:", error);
      failed = true;
      render();
    });
});
